import { commonMenuItems } from "./common";
import defaultProfile from "./default";
import type { GameProfile, type Menu, ProfileCtx } from "./types";

const createMenu = (): Menu => {
  const menu = defaultProfile().menu;
  menu[0].items.push(commonMenuItems.logs);
  return menu;
};

export default (_ctx: ProfileCtx): Partial<GameProfile> => ({
  menu: createMenu(),
});
